import ReviewAttribute from "../../../../Components/SharedComponent/ReviewAttribute/ReviewAttribute";
import ReviewSummarySectionHeading from "../../../../Components/SharedComponent/ReviewSummarySectionHeading/ReviewSummarySectionHeading";
import { toTitleCase } from "../../../../Utils/stringUtls";
import { technologySpecforMobileSDKOptions } from "../../InterfacesAndComponents/stringUtils";


const I2cMobileSDKApplicationOverview = ({ data }) => {
  const {
    sdk_would_you_like_i2c_hosted_mobile_sdk_application,
    sdk_technology_specification_for_i2c_mobile_sdk_integration,
    sdk_technology_specification_for_i2c_mobile_sdk_integration_other,
    sdk_i2c_hosted_mobile_sdk_language,
    sdk_i2c_hosted_mobile_sdk_language_other,
  } = data["3_9"];

  const techValue = [
    ...(sdk_technology_specification_for_i2c_mobile_sdk_integration ?? [])
      .filter((l) => l?.length && l !== "other")
      .map((val) => {
        const match = technologySpecforMobileSDKOptions.find((o) => o.value === val);
        return match ? match.label : toTitleCase(val);
      }),
    ...(sdk_technology_specification_for_i2c_mobile_sdk_integration?.includes(
      "other",
    ) &&
    sdk_technology_specification_for_i2c_mobile_sdk_integration_other?.length
      ? [
          `Other (${toTitleCase(sdk_technology_specification_for_i2c_mobile_sdk_integration_other)})`,
        ]
      : []),
  ].join(", ");

  const languageValue = [
    ...(sdk_i2c_hosted_mobile_sdk_language ?? [])
      .filter((l) => l?.length && l !== "other")
      .map(toTitleCase),
    ...(sdk_i2c_hosted_mobile_sdk_language?.includes("other") &&
    sdk_i2c_hosted_mobile_sdk_language_other?.length
      ? [`Other (${toTitleCase(sdk_i2c_hosted_mobile_sdk_language_other)})`]
      : []),
  ].join(", ");

  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid grid" className="review-summary-gap">
        <div i2c-grid="12@md">
          <ReviewSummarySectionHeading title="i2c Mobile SDK Application" />
        </div>
        <ReviewAttribute
          label="Would you like i2c hosted “Mobile SDK Application”?"
          value={
            sdk_would_you_like_i2c_hosted_mobile_sdk_application?.length
              ? toTitleCase(
                  sdk_would_you_like_i2c_hosted_mobile_sdk_application,
                )
              : "-"
          }
        />
        <ReviewAttribute
          label="Technology Specification for i2c Mobile SDK Integration"
          value={techValue || "-"}
        />
        <ReviewAttribute
          label="i2c Hosted Mobile SDK Language"
          value={languageValue || "-"}
        />
      </div>
    </div>
  );
};
export default I2cMobileSDKApplicationOverview;
